import { hasContentfulLocale, toContentfulLocale } from '../../locale/constants';
import { dictionaries, localDictionaries } from '../store';
import { clearLookupsCache } from '../lookups';
import { getContentfulDeliveryConfig } from './config';
import { fetchContentfulEntries } from './fetch';
import { COPY_NAMESPACES, cloneJson, deepMerge, mapContentfulEntries } from './map';

/**
 * Overlay Contentful copy/catalogs onto local src/content for one locale.
 * On missing env, abort, or network/CDA errors: leave dictionaries as they
 * are (local files until a successful fetch; last good overlay after that).
 */
export async function syncContentfulLocale(locale, signal) {
  if (!hasContentfulLocale(locale)) return false;
  if (!getContentfulDeliveryConfig()) return false;

  try {
    const contentfulLocale = toContentfulLocale(locale);
    const payload = await fetchContentfulEntries(contentfulLocale, signal);
    if (!payload) return false;
    const overlay = mapContentfulEntries(payload, contentfulLocale);
    const bundleCount = COPY_NAMESPACES.filter((namespace) => overlay[namespace]).length;
    if (bundleCount === 0 && typeof console !== 'undefined') {
      console.warn(
        'Contentful returned no Talents copyBundle entries; UI copy stays on local src/content.'
      );
    }
    const base = cloneJson(localDictionaries[locale] || localDictionaries.en);
    dictionaries[locale] = deepMerge(base, overlay);
    clearLookupsCache(locale);
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    if (typeof console !== 'undefined') {
      console.warn('Contentful copy fetch failed; using local dictionaries.', error);
    }
    return false;
  }
}
